import React from "react";
import { connect } from "react-redux";
import { Spin, Empty, Avatar, Flex, Badge, Tooltip, Button } from "antd";
import { FormatTimeAgo } from "../../helpers/formatTimeAgo";
import moment from "moment";
import { calculateAccountUsage } from "../../helpers/calculate";
import { withTranslation } from "react-i18next";
import { formatPromptPayNumber } from "../../utils";
import { BankOutlined, ExportOutlined } from "@ant-design/icons";
import { CopyTextToClipboard } from "../../helpers/copy";
// import LogoWhite from "../../assets/images/logo/payeasy1.1.png";
import config from "../../config/app.config";

/**
 * Functional Component สำหรับแสดงรายละเอียดบัญชีถอนเงิน
 * @param {object} item - ข้อมูลบัญชีแต่ละรายการ
 * @param {boolean} loadingBankAccounts - สถานะการโหลดข้อมูล
 * @param {function} t - ฟังก์ชันสำหรับจัดการภาษา
 */
const BankAccountItem = ({ item, loadingBankAccounts, t }) => (
  <div className="row clearfix">
    <div className="col-lg-6 col-sm-6  mb-3">
      <div className="receipt-left">
        <Flex gap={5} align="center" direction="horizontal" size={16}>
          <Avatar size={24} src={item?.bank.imageUrl} />
          <h5
            title={t(item?.bank?.bank_id)}
            className="text-truncate"
            style={{ marginBottom: 0, maxWidth: 200 }}
          >
            {t(item?.bank?.bank_id)}
          </h5>
        </Flex>
        <div
          className="mt-3 mb-1 text-truncate"
          title={item?.accountName}
          style={{ maxWidth: "180px" }}
        >
          <b>{t("account name")}</b>
          <>
            <code style={{ color: "rgb(90 90 90)" }}>
              {" "}
              : {item?.accountName}
            </code>
          </>
        </div>
        <div className="">
          <b>{t("account number")}</b>
          <code
            style={{ cursor: "copy", color: "rgb(90 90 90)" }}
            onClick={() => CopyTextToClipboard(item?.accountNumber)}
          >
            {" "}
            : {formatPromptPayNumber(item?.accountNumber)}
          </code>
        </div>
        <div className="">
          <b>{t("Type")}</b>
          <code style={{ color: "rgb(90 90 90)" }}>
            {" "}
            :{" "}
            {item?.accountType === "verifying_account"
              ? t("verify_hub")
              : item?.accountType}
          </code>
        </div>
      </div>
    </div>
    <div className="col-lg-6 col-sm-6 text-right">
      <br className="hidden-sm" />
      <br className="hidden-sm" />
      <br className="hidden-sm" />
      <div className="mb-0 ">
        <h4>
          {loadingBankAccounts ? (
            <i
              className="bx bx-loader-circle bx-spin"
              style={{ color: "#888" }}
            ></i>
          ) : (
            <>
              <span
                id="balance-payout"
                data-bank-id={item?.id}
                data-original={item?.balance}
              >
                {!loadingBankAccounts ? (
                  <code style={{ color: "rgb(90 90 90)" }}>
                    ฿ {Intl.NumberFormat().format(item?.balance)}
                  </code>
                ) : (
                  <i className="bx bx-loader-circle bx-spin"></i>
                )}
              </span>{" "}
            </>
          )}
        </h4>
      </div>
      <p className="mb-0">
        {t("Remaining credit limit")} :{" "}
        <code style={{ color: "rgb(90 90 90)" }}>
          {Intl.NumberFormat().format(item?.limit_Left)}
        </code>
        .-
      </p>
      <p className="mb-0 ">
        {t("Already used")} :{" "}
        <code style={{ color: "rgb(90 90 90)" }}>
          {calculateAccountUsage(item)}
        </code>{" "}
        {t("day")}
      </p>
      <div>
        <b>{t("Latest update")} :</b>{" "}
        <Tooltip
          placement="top"
          title={moment(item?.updated_at)
            .locale("th")
            .format("YYYY/MM/DD HH:mm:ss")}
        >
          <b>{FormatTimeAgo(item?.updated_at)}</b>
        </Tooltip>
      </div>
    </div>
  </div>
);

const BankAccountSysem = ({ t }) => (
  <div className="row clearfix">
    <div className="col-lg-6 col-sm-6  mb-3 mt-3">
      <div className="receipt-left">
        <Flex gap={5} align="center" direction="horizontal" size={16}>
          <Avatar
            size={36}
            style={{ background: "hsla(215, 100%, 54%, 0.00)" }}
            icon={<BankOutlined style={{ color: "rgb(90 90 90)" }} />}
          />
          <br />
          <span className="" style={{ marginBottom: 0 }}>
            {t("ตรวจสอบบัญชีลูกค้าของระบบ", { web_name: config.web_name })}
          </span>
        </Flex>
      </div>
    </div>
  </div>
);

class VerifyAccount extends React.Component {
  /**
   * ฟังก์ชันจัดการข้อมูลบัญชีและแสดงผล
   * @param {Array} verifyAcc - ข้อมูลบัญชีทั้งหมด
   */
  handleDataAccount = (verifyAcc) => {
    const { t, spinnerID, history } = this.props; // , handleReload
    const verifyAccount = Array.isArray(verifyAcc)
      ? verifyAcc.filter(
        (o) =>
          o?.accountType === "verifying_account" &&
          o?.status_bank === "Active",
      )
      : [];

    if (verifyAccount?.length === 0) {
      return (
        <Empty
          children={
            <Button
              icon={<ExportOutlined />}
              onClick={() => history.push("/setting")}
            >
              {t("เปิดใช้งานบริการตรวจสอบบัญชีลูกค้า")}
            </Button>
          }
          description={t("No verified account")}
        />
      );
    }

    return verifyAccount?.map((item) => (
      <React.Fragment key={item?.id}>
        <Spin spinning={item?.id === spinnerID}>
          <BankAccountItem
            item={item}
            loadingBankAccounts={item?.id === spinnerID}
            t={t}
          />
        </Spin>
      </React.Fragment>
    ));
  };

  handleVerifySystem = () => {
    const { t } = this.props; // , handleReload
    return (
      <React.Fragment>
        <Spin spinning={false}>
          <BankAccountSysem t={t} />
        </Spin>
      </React.Fragment>
    );
  };

  render() {
    const { activeAccountData, t, enabled_verify_hub } = this.props;

    return (
      <Badge.Ribbon
        text={
          <span style={{ color: "#fff", fontWeight: "500" }}>
            {t("verify_hub")}
          </span>
        }
        color="#227df5ff"
      >
        <div className="card" style={{ padding: "15px" }}>
          <div className="body">
            {enabled_verify_hub ? (
              <>{this.handleVerifySystem()}</>
            ) : (
              <>{this.handleDataAccount(activeAccountData)}</>
            )}
          </div>
        </div>
      </Badge.Ribbon>
    );
  }
}

const mapStateToProps = ({ UIElementsReducer }) => ({});

export default connect(mapStateToProps, {})(withTranslation()(VerifyAccount));
